var _a;
const defaultExtractDetails = async (response) => {
    try {
        const details = await response.json();
        return {
            title: details.title,
            detail: details.detail,
            fields: details.fields,
        };
    }
    catch (error) {
        return {
            title: 'Error',
            detail: response.statusText,
        };
    }
};
const ERROR_KEY = Symbol.for('eventstore/HTTPError');
/** A standardised HTTP request error. Works together with [Working Data](/fields/utils/createWorkingData) to assign HTTPProblemDetails fields to errors on form fields. */
class HTTPError extends Error {
    static isHTTPError(error) {
        return error instanceof Error && ERROR_KEY in error;
    }
    static fromDetails(details) {
        return new HTTPError(new Response(), async () => details);
    }
    /** Construct a HTTPError from a Fetch Response and an an optional details extractor. */
    constructor(response, extractDetails = defaultExtractDetails) {
        super(`${response.status} ${response.statusText}`);
        this[_a] = true;
        /** Extract the HTTPProblemDetails from the Response. */
        this.details = () => {
            if (!this.detailsPromise) {
                this.detailsPromise = this.extractDetails(this.response);
            }
            return this.detailsPromise;
        };
        Object.setPrototypeOf(this, new.target.prototype);
        this.name = HTTPError.name;
        this.status = response.status;
        this.statusText = response.statusText;
        this.response = response;
        this.extractDetails = extractDetails;
    }
}
_a = ERROR_KEY;

export { HTTPError };
